import {
    Component,
    Input,
    ComponentFactoryResolver,
    ViewContainerRef,
    ViewEncapsulation,
    OnDestroy
} from '@angular/core';

import { BotService } from './../_bot/_bot.service';
import { RenderCardHero } from './messageRenders/renderCardHero/renderCardHero.component';
import { RenderPlainText } from './messageRenders/renderPlainText/renderPlainText.component';
import { RenderUserPlainText } from './messageRenders/renderUserMessage/renderUserMessage.component'
import { RenderCardThumbnail } from './messageRenders/renderCardThumbnail/renderCardThumbnail.component';
import { RenderCardAdaptive } from './messageRenders/renderCardAdaptive/renderCardAdaptive.component';
import { RenderReconnectText } from './messageRenders/renderReconnectText/renderReconnectText.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'message',
    templateUrl: 'message.component.html',
    styleUrls: ['./message.component.scss'],
    entryComponents: [
        RenderCardHero,
        RenderPlainText,
        RenderUserPlainText,
        RenderCardThumbnail,
        RenderCardAdaptive,
        RenderReconnectText
    ],
    encapsulation: ViewEncapsulation.None
})
export class MessageComponent implements OnDestroy{

    // Dinamic render component
    private Component: any;
    // Render messages object indexs
    private entryComponentsArray = {
        "application/vnd.microsoft.card.hero": RenderCardHero,
        "application/plain.text": RenderPlainText,
        "application/vnd.microsoft.card.thumbnail": RenderCardThumbnail,
        "application/vnd.microsoft.card.adaptive": RenderCardAdaptive,
        "application/reconnect.text": RenderReconnectText
    }
    clickSubscription: Subscription;

    @Input() set messageBody(messageBody: any) {
        if (messageBody) {
            this.createMessageComponent(this.entryComponentsArray[messageBody.contentType])
                .renderBotMessage(messageBody.content)
                .postItMessage();
        }
    }

    constructor(
        private factoryResolver: ComponentFactoryResolver,
        private viewContainerRef: ViewContainerRef,
        private BotService: BotService,
        private store: Store<AppState>
    ) { }

    createMessageComponent(comp) {
        this.Component = this.factoryResolver
            .resolveComponentFactory(comp)
            .create(this.viewContainerRef.parentInjector);
        return this;
    }

    renderBotMessage(data) {
        this.Component.instance.data = data;
        this.getAndPostUserInteraction(); // subscribe in emmiter bot message (when user interaction)
        return this;
    }

    renderUserMessage(data) {
        this.Component.instance.data = data.value;
        this.Component.instance.inicialPosition = {
            top: data.event.target.getBoundingClientRect().top,
            left: data.event.target.getBoundingClientRect().left
        };
        return this;
    }

    postItMessage() {
        this.viewContainerRef.insert(this.Component.hostView);
    }

    // subscribe in bot message, to get user interaction
    getAndPostUserInteraction() {
        if (this.Component.instance.clickEvent) {
            this.clickSubscription = this.Component.instance.clickEvent
                .take(1)
                .subscribe(data => {

                    this.BotService.sendMessage(data.value);

                    this.createMessageComponent(RenderUserPlainText)
                        .renderUserMessage(data)
                        .postItMessage();
                });
        }
    }

    //não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    ngOnDestroy() { }
}